const reviewCarousels = document.querySelectorAll('.review--carousel.swiper');

reviewCarousels.forEach(reviewCarousel => {
    new Swiper(reviewCarousel, {
        loop: true,
        autoplay: {
            delay: 7000,
        },
      	autoHeight: true,
      resizeObserver: false,
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
            el: '.review--carousel .swiper-pagination',
        },
        navigation: {
            nextEl: '.review--carousel .swiper-button-next',
            prevEl: '.review--carousel .swiper-button-prev',
        }
    });

});

